/*
 * @Description: Description
 * @Author: Yongchao Wang
 * @Date: 2021-07-06 15:10:26
 * @LastEditors: lixin jiang
 * @LastEditTime: 2021-07-15 16:14:47
 */
import AidRectCheckbox from './aidRectCheckbox';

export default AidRectCheckbox;
